var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeOcultar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70711 0.496598C2.31658 0.106074 1.68342 0.106074 1.29289 0.496598C0.902369 0.887122 0.902369 1.52029 1.29289 1.91081L3.71706 4.33498C2.28639 5.41108 1.03925 6.88914 0.105573 8.75649C-0.0351909 9.03802 -0.0351909 9.36939 0.105573 9.65092C2.26379 13.9674 6.09687 16.2037 10 16.2037C11.5552 16.2037 13.0992 15.8487 14.5306 15.1485L17.2929 17.9108C17.6834 18.3013 18.3166 18.3013 18.7071 17.9108C19.0976 17.5203 19.0976 16.8871 18.7071 16.4966L2.70711 0.496598ZM13.0138 13.6317L11.2934 11.9113C10.9018 12.0988 10.4631 12.2037 10 12.2037C8.34315 12.2037 7 10.8606 7 9.20371C7 8.74056 7.10495 8.30193 7.29237 7.91029L5.14838 5.7663C3.98778 6.58311 2.94721 7.72507 2.12966 9.20371C3.99806 12.5829 7.03121 14.2037 10 14.2037C11.0134 14.2037 12.0343 14.0149 13.0138 13.6317Z",
    fill: "#747488"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5523 11.0992C17.0353 10.5439 17.4784 9.91246 17.8703 9.2037C16.0019 5.82448 12.9687 4.2037 9.99996 4.2037C9.88796 4.2037 9.77586 4.20601 9.66374 4.21063L7.87939 2.42628C8.57741 2.27821 9.28752 2.2037 9.99996 2.2037C13.9031 2.2037 17.7362 4.44005 19.8944 8.75649C20.0352 9.03802 20.0352 9.36939 19.8944 9.65092C19.3504 10.7389 18.7 11.6947 17.9689 12.5158L16.5523 11.0992Z",
    fill: "#747488"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeOcultar);
export default __webpack_public_path__ + "static/media/icone-ocultar.ce16b92ce1faaa5db00b8677d21dc873.svg";
export { ForwardRef as ReactComponent };